import {
  TablePagination,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Box,
  makeStyles,
  Typography,
  ButtonGroup,
  InputBase,
  withStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  Snackbar,
  CircularProgress,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  TextField,
  NativeSelect
} from "@material-ui/core";
import { useEffect, useState } from 'react'
import { FetchCoachList, GetEnterprisesRequest, UpdateCoachStatus } from './apis/api';
import moment from "moment";

let headers = [
  "First Name",
  "Last Name",
  "Phone",
  "Email",
  "Requested at",
  "Action"
];

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
  },
  table: {
    minWidth: 1050,
  },
  tableHeadCell: {
    fontSize: "18px",
  },
  tableRowCell: {
    fontSize: "14px",
    borderBottom: "none",
    lineHeight: "40px",
    align: "left",
  },
  dropdown: {
    position: "absolute",
    top: 28,
    right: 0,
    left: 0,
    zIndex: 1,
    border: "1px solid",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#f2f2f2",
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    fontSize: "14px",
  },
  inputInput: {
    padding: theme.spacing(1.5, 1.5, 1.5, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
}));

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);
// end of css
export function EnterpriseRequestsPage() {
  const classes = useStyles();

  const [coachesList, setCoachesList] = useState([]);
  const [requests, setRequests] = useState([]);
  const [pending, setPending] = useState(false);

  const [isEntModelOpen, setIsEntModelOpen] = useState(false);
  const [entpForm, setEntpForm] = useState(() => ({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    comment: '',
    coaches: '',
    user: null,
    createdAt: ''
  }))

  const [btnPending, setBtnPending] = useState(false)

  const [snack, setSnack] = useState(()=>({
    message: '',
    open: false
  }))

  const [filter, setFilter] = useState('PENDING')

  const fetchCoaches = async (status) => {
    setPending(true);
    // console.log(status);
    let coaches = await FetchCoachList(status);
    setCoachesList(coaches.data.users);
    setPending(false);
  }

  const fetchRequest = async () => {
    setPending(true);
    // console.log(status);
    let res = await GetEnterprisesRequest();
    setRequests(res.data.data);
    setPending(false);
  }

  const handleUpdateSatus = async (id, status) => {
    setBtnPending(true);
    let coaches = await UpdateCoachStatus(id, status);
    setSnack((pre)=>({
      ...pre,
      open: true,
      message: coaches.data.message
    }));
    setBtnPending(false);
    fetchCoaches(filter);
  }
  

  // useEffect(()=>{
  //   fetchCoaches()
  // },[])

  useEffect(()=>{
    // console.log(filter);
    // fetchCoaches(filter)
    fetchRequest();
  }, [])

  const handleOpenDialog = async (data) => {
    setEntpForm(data);
    setIsEntModelOpen(true);
  }

  return (
    <div>
      <Snackbar
        open={snack.open}
        autoHideDuration={2000}
        message={snack.message}
        onClose={()=>{
          setSnack(()=>({
            open: false,
            message: ""
          }))
        }}
      />
      <div className="col-sm-12 mb-5 d-flex justify-content-between">
        <Typography variant="h4" className="font-weight-bold">
          Enterprises Requests
        </Typography>
        <Button
            variant="outlined"
            //   onClick={() => openAssignCoach(row)}
            style={{
              backgroundColor: "#ffffff",
              color: "#28d604",
              borderColor: "#28d604",
              // marginLeft: "100px"
              // width: 'max-content'
            }}
            onClick={()=>{fetchRequest()}}
          >
            <Typography>Refresh List</Typography>
          </Button>
      </div>
      <TableContainer className="mt-10">
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              {headers.map((item, index) => (
                <TableCell
                  key={index}
                  align="left"
                  classes={{ root: classes.tableHeadCell }}
                >
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {!pending ? 
            requests.length == 0 ?
            <TableBody>
              <TableCell align="center" colSpan={6}>
                {"No Requests available"}
              </TableCell>
            </TableBody>
            
            :
            <TableBody>
            {requests.map((row, index) => (
              <StyledTableRow key={index}>
                <TableCell
                  classes={{
                    root: classes.tableRowCell,
                  }}
                  component="th"
                  scope="row"
                  align="left"
                  // onClick={() => openUserDetails(row)}
                >
                  {row.firstName}
                </TableCell>
                <TableCell
                  align="left"
                  classes={{ root: classes.tableRowCell }}
                >
                  {row.lastName}
                </TableCell>
                <TableCell
                  align="left"
                  classes={{ root: classes.tableRowCell }}
                >
                  {row.phone}
                </TableCell>
                <TableCell
                  align="left"
                  classes={{ root: classes.tableRowCell }}
                >
                  {row.email}
                </TableCell>
                <TableCell
                  align="left"
                  classes={{ root: classes.tableRowCell }}
                >
                  {moment(row.createdAt).format('YYYY-MM-DD hh:mm A')}
                </TableCell>
                <TableCell
                  align="left"
                  classes={{ root: classes.tableRowCell }}
                >
                  {<div className="d-flex">
                    <Button
                      variant="outlined"
                      //   onClick={() => openAssignCoach(row)}
                      style={{
                        backgroundColor: "#ffffff",
                        color: "#28d604",
                        borderColor: "#28d604",
                        // width: 'max-content'
                      }}
                      onClick={()=>{handleOpenDialog(row)}}
                    >
                      <Typography>View</Typography>
                    </Button>
                  </div> }
                </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
          :
          <TableBody>
            <TableCell align="center" colSpan={6}>
              <CircularProgress />
            </TableCell>
          </TableBody>
          }
        </Table>
      </TableContainer>
      <Dialog
        open={isEntModelOpen}
        onClose={() => { setIsEntModelOpen(false) }}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        // fullWidth="100%"
        fullWidth={true}
      >
        <DialogTitle id="form-dialog-title">
          <Typography variant="h6" color={'black'}>Request Detail</Typography>
        </DialogTitle>
        <DialogContent>
          <Grid
            // className="px-5 mb-4"
            container
            direction="row"
            // justify="space-between"
            spacing={2}
            width={'100%'}
          >
            <Grid item md={6} width={'100%'}>
              {/* <TextField
                style={{ width: "100%" }}
                className="form-control form-control-solid h-auto w-100 py-5 px-6"
                margin="dense"
                label="First Name *"
                disabled={true}
                placeholder="First Name *"
                name='firstName'
                value={entpForm.firstName}
                onChange={(evt) => setEntpForm((pre)=>({...pre, firstName: evt.target.value}))}
              /> */}
              <label style={{ fontWeight: 'bold' }} >First Name</label>
              <p>{entpForm.firstName}</p>
            </Grid>
            <Grid item md={6} width={'100%'}>
              {/* <TextField
                style={{ width: "100%" }}
                className="form-control form-control-solid h-auto py-5 px-6"
                margin="dense"
                placeholder="Last Name *"
                disabled={true}
                label="Last Name *"
                name='lastName'
                value={entpForm.lastName}
                onChange={(evt) => setEntpForm((pre)=>({...pre, lastName: evt.target.value}))}
              /> */}
              <label style={{ fontWeight: 'bold' }} >Last Name</label>
              <p>{entpForm.lastName}</p>
            </Grid>
          </Grid>
          <Grid
            // className="px-5 mb-4"
            container
            direction="row"
            // justify="space-between"
            spacing={2}
            width={'100%'}
          >
            <Grid item md={6} width={'100%'}>
              {/* <TextField
                style={{ width: "100%" }}
                className="form-control form-control-solid h-auto w-100 py-5 px-6"
                margin="dense"
                placeholder="Phone *"
                disabled={true}
                label="Phone *"
                value={entpForm.phone}
                onChange={(evt) => setEntpForm((pre)=>({...pre, phone: evt.target.value}))}
              /> */}
              <label style={{ fontWeight: 'bold' }} >Phone</label>
              <p>{entpForm.phone}</p>
            </Grid>
            <Grid item md={6} width={'100%'}>
              {/* <TextField
                style={{ width: "100%" }}
                className="form-control form-control-solid h-auto py-5 px-6"
                margin="dense"
                placeholder="Email *"
                disabled={true}
                label="Email"
                type="email"
                value={entpForm.email}
                onChange={(evt) => setEntpForm((pre)=>({...pre, email: evt.target.value}))}
                required
              /> */}
              <label style={{ fontWeight: 'bold' }} >Email</label>
              <p>{entpForm.email}</p>
            </Grid>
          </Grid>
          <Grid
            // className="px-5 mb-4"
            container
            direction="row"
            // justify="space-between"
            spacing={2}
            width={'100%'}
          >
            <Grid item md={6} width={'100%'}>
              {/* <TextField
                style={{ width: "100%" }}
                className="form-control form-control-solid h-auto w-100 py-5 px-6"
                margin="dense"
                placeholder="Coaches Size *"
                disabled={true}
                label="Coaches Size *"
                type="number"
                value={entpForm.coaches}
                onChange={(evt) => setEntpForm((pre)=>({...pre, coaches: evt.target.value}))}
              /> */}
              <label style={{ fontWeight: 'bold' }} >Coaches Size</label>
              <p>{entpForm.coaches}</p>
            </Grid>
            <Grid item md={6} width={'100%'}>
              {/* <TextField
                style={{ width: "100%" }}
                className="form-control form-control-solid h-auto w-100 py-5 px-6"
                margin="dense"
                placeholder="Coaches Size *"
                disabled={true}
                label="Coaches Size *"
                type="number"
                value={entpForm.coaches}
                onChange={(evt) => setEntpForm((pre)=>({...pre, coaches: evt.target.value}))}
              /> */}
              <label style={{ fontWeight: 'bold' }} >Requested at</label>
              <p>{moment(entpForm.createdAt).format('YYYY-MM-DD hh:mm A')}</p>
            </Grid>
          </Grid>
          <Grid
            // className="px-5 mb-4"
            container
            direction="row"
            // justify="space-between"
            spacing={2}
            width={'100%'}
            style={{marginTop: '0px'}}
          >
            <Grid item md={12} width={'100%'}>
              <label style={{ fontWeight: 'bold' }} >Comment</label>
              {/* <TextareaAutosize
                style={{ width: "100%", border: '1px solid #909090', borderRadius: '4px' }}
                className="form-control form-control-solid h-auto w-100 py-5 px-6"
                disabled={true}
                placeholder="Comment *"
                minRows={3}
                value={entpForm.comment}
                onChange={(evt) => setEntpForm((pre)=>({...pre, comment: evt.target.value}))}
              /> */}
              <p style={{textAlign:'justify'}}>
                {entpForm.comment}
              </p>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid
            className="px-5 mb-4"
            container
            direction="row"
            justifyContent="flex-end"
          // justify="space-between"
          >
            <Grid item>
            <Button
              variant="outlined"
              style={{
                borderColor: "#fc7e7e",
                color: "#fc7e7e",
                backgroundColor: "#ffffff",
              }}
              onClick={() => { setIsEntModelOpen(false) }}
              // onClick={() => {
              //   handleBlock(row.id, row.name);
              // }}
              className="pl-7 pr-8 ml-3"
            >
              <Typography>Close</Typography>
            </Button>
              {/* <Button
                // size="large"
                onClick={() => { setIsEntModelOpen(false) }}
                color="error"
              // variant={"contained"}
              >
                Close
              </Button> */}
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}
